module.exports = __webpack_public_path__ + "19774dfbb4a84861bc2983c26223c9f5.png";